var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logout 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bulk/Logout"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logout"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    opacity: 0.4,
    d: "M2.12988 5.34672C2.12988 3.51345 3.64844 2.02051 5.51409 2.02051H9.22483C11.0867 2.02051 12.6014 3.50896 12.6014 5.33924V13.6536C12.6014 15.4877 11.0829 16.9799 9.21646 16.9799H5.50724C3.64463 16.9799 2.12988 15.4914 2.12988 13.6611V12.958V5.34672Z",
    fill: "#E5B910"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M16.9237 9.09199L14.7952 6.91615C14.5752 6.69176 14.2212 6.69176 14.0019 6.91765C13.7834 7.14354 13.7841 7.50779 14.0034 7.73219L15.1696 8.9237H14.0514H7.77576C7.46616 8.9237 7.21484 9.18175 7.21484 9.49963C7.21484 9.81827 7.46616 10.0756 7.77576 10.0756H15.1696L14.0034 11.2671C13.7841 11.4915 13.7834 11.8557 14.0019 12.0816C14.1119 12.1946 14.2554 12.2514 14.3996 12.2514C14.5424 12.2514 14.6859 12.1946 14.7952 12.0831L16.9237 9.90802C17.0294 9.79957 17.0891 9.65297 17.0891 9.49963C17.0891 9.34705 17.0294 9.20044 16.9237 9.09199Z",
    fill: "#E5B910"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout1);
export default __webpack_public_path__ + "static/media/logout-1.2156263bc49d6f27d6c9f7e10ee7986a.svg";
export { ForwardRef as ReactComponent };